import styled, { css } from 'styled-components';
import { th } from 'style/theme';
import { sizes, fadeIn } from 'style';

export const Bg = styled.div`
  background-color: ${({ bg }) => th(`colors.${bg}`)};

  ${({ isLoading }) =>
    isLoading &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      min-height: 100svh;
      height: 100%;
    `}
`;

export const StyledContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 1600px;
  min-height: 100svh;
  padding: 40px 20px;
  padding-top: ${({ paddingTop }) => paddingTop || '90px'};
  margin: 0 auto;
  animation: ${fadeIn} 0.25s linear;

  @media ${sizes.tabletPortrait} {
    padding: 40px;
    padding-top: ${({ paddingTop }) => paddingTop || '90px'};
  }

  @media ${sizes.desktop} {
    padding-top: 110px;
  }
`;
